
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/redeem/[[...promocode]]",
      function () {
        return require("private-next-pages/redeem/[[...promocode]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/redeem/[[...promocode]]"])
      });
    }
  